// Pagine di registrazione: tutte sul web, solo signup nella DesktopApp,
// nessuna in HBO.
export default function ({ app, route, store, redirect }) {
  const isShared = store.getters['utils/isShared']
  const isStandalone = store.getters['utils/isStandalone']

  if (isShared || (isStandalone && app.getRouteBaseName(route) !== 'signup')) {
    redirect(app.localePath('index'))
  }
}
